jQuery_T4NT(document).ready(function($) {

  setTimeout(function(){
    $('img').each(function(){
      $(this).attr('width', 'auto')
      $(this).attr('height', 'auto')
      if($(this).attr('alt') == "" || $(this).attr('alt') == 'undefined' || $(this).attr('alt') == 'null'){
        $(this).attr('alt', 'image')
      }
    })
    $('a').each(function(){
        $(this).attr('aria-label', 'link')
    })
    $('button').each(function(){
        $(this).attr('aria-label', 'button')
    })
    $('frame, iframe').each(function(){
        $(this).attr('aria-label', 'frame')
    })    
  },1000)

     /**
     * Variant selection changed
     */
	  $( document ).on( "variant:change", function( evt, variant ) {
	    //console.log( variant );
	  });
  window.onscroll = function() {myFunction()};

  var navbar = document.getElementById("sticky-header");
  var mob_navbar = document.getElementById("shopify-section-header_4");


  var sticky = navbar.offsetTop;
  var mob_sticky = mob_navbar.offsetTop;


  function myFunction() {

    if(window.innerWidth < 1025){
//       console.log("screen.width",window.innerWidth, window.pageYOffset,mob_sticky)
      if (window.pageYOffset >= mob_sticky) {
//         console.log('1');
        mob_navbar.classList.add("sticky")
      } else {
        mob_navbar.classList.remove("sticky");
//         console.log('2');
      }
      
    }else{
//       console.log("screen.width 2",window.innerWidth, window.pageYOffset,sticky)

      if (window.pageYOffset >= sticky) {
        navbar.classList.add("sticky")
      } else {
        navbar.classList.remove("sticky");
      }
      
    }

  }
  
});
var data = $('.rightCstmCol .swiper-slide ');
if(data.length < 6){
  $('.collectionSlider .swiper-arr').hide();
}else{
   $('.collectionSlider .swiper-arr').attr("style", "opacity:1!important")
}


$('.comp_next.active').click(function () {
    var total__page = parseInt($('.comp_total_num').text());
   var c_page_no = parseInt($('.current_num').text());
    
    if(c_page_no < total__page){
    $('.current_num').html(c_page_no+1);
    c_page_no =c_page_no+1;
   
    $('.comp__products').addClass('compl_hide');
    var total_value = c_page_no * 2;
    var second_last =total_value-1;
      $('.comp__produt_sec [data-index="'+second_last+'"]').removeClass("compl_hide");
      $('.comp__produt_sec [data-index="'+total_value+'"]').removeClass("compl_hide");
    }
   
});


$(document).on('click','.comp_back.active',function(){
   var c_page_no = parseInt($('.current_num').text());
    if(c_page_no>1){
     $('.current_num').html(c_page_no-1);
    c_page_no = c_page_no-1
    $('.comp__products ').addClass('compl_hide');
    var total_value = c_page_no * 2;
    var second_last =total_value-1;
      $('.comp__produt_sec [data-index="'+second_last+'"]').removeClass("compl_hide");
      $('.comp__produt_sec [data-index="'+total_value+'"]').removeClass("compl_hide");
    }
   
});





